import { useCallback, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

async function pollComic(jobId) {
  for (let i = 0; i < 60; i++) {
    await wait(3000);
    const { data } = await api.get(`/versions/c/${jobId}`);
    if (data.status === "done") return data.result;
    if (data.status === "error") throw new Error(data.error || "Generazione manga non riuscita");
  }
  throw new Error("Tempo scaduto per la generazione del manga");
}

const fetchers = {
  a: (text) => api.post("/mindmap", { text }).then((r) => r.data),
  b: (text) => api.post("/versions/b", { text }).then((r) => r.data),
  c: (text) => api.post("/versions/c", { text }).then((r) => pollComic(r.data.job_id)),
};

export function useStudyVersions() {
  const [versions, setVersions] = useState({ a: null, b: null, c: null });
  const [loading, setLoading] = useState({});
  const [ver, setVer] = useState("a");
  const [workId, setWorkId] = useState(null);
  const [saved, setSaved] = useState(false);

  const reset = useCallback(() => {
    setVersions({ a: null, b: null, c: null });
    setVer("a"); setWorkId(null); setSaved(false);
  }, []);

  const generate = useCallback(async (v, text) => {
    setLoading((l) => ({ ...l, [v]: true }));
    try {
      const data = await fetchers[v](text);
      setVersions((vs) => (v === "a" ? { a: data, b: null, c: null } : { ...vs, [v]: data }));
      if (v === "a") { setVer("a"); setWorkId(null); } else toast.success(`Versione ${v.toUpperCase()} pronta`);
      setSaved(false);
      return data;
    } catch (e) {
      toast.error(errMsg(e));
      return null;
    } finally {
      setLoading((l) => ({ ...l, [v]: false }));
    }
  }, []);

  const select = useCallback((v, text) => {
    setVer(v);
    if (!versions[v] && !loading[v]) generate(v, text);
  }, [versions, loading, generate]);

  const save = useCallback(async (meta) => {
    setLoading((l) => ({ ...l, save: true }));
    try {
      const payload = { version_b: versions.b, version_c: versions.c };
      if (workId) await api.patch(`/works/${workId}`, payload);
      else {
        const { data } = await api.post("/works", { ...meta, mindmap: versions.a, ...payload });
        setWorkId(data.id);
      }
      setSaved(true);
      toast.success("Versioni salvate in “I miei Lavori”");
    } catch (e) { toast.error(errMsg(e)); } finally { setLoading((l) => ({ ...l, save: false })); }
  }, [versions, workId]);

  return { versions, loading, ver, workId, saved, reset, generate, select, save };
}
